export const StringHelper = {
  capitalize: (string: string) =>
    string.charAt(0).toUpperCase() + string.slice(1),

  containsNonNumericCharacters: (str: string) => {
    return /[a-zäöü/*#'_,:;!"§$%&()=?`´]/i.test(str);
  },

  isValidString: (string: unknown): string is string =>
    typeof string === 'string' && string.trim() !== '',

  countStringOccurrences: (str: string, subStr: string) => {
    // Split the string by the substring and count the length of the resulting array
    return str.split(subStr).length - 1;
  },

  removeString: (original: string, substring: string) => {
    if (!original.includes(substring)) return original;
    return original.replace(substring, '');
  },

  removeStringByIndex: (original: string, index: number, deleteCount: number) =>
    original.substring(0, index) + original.substring(index + deleteCount),

  removeLastOccurence: (original: string, substring: string) => {
    const lastIndex = original.lastIndexOf(substring);
    if (lastIndex === -1) return original;
    return (
      original.substring(0, lastIndex) +
      original.substring(lastIndex + substring.length)
    );
  },
};
